import * as React from 'react';
import { DirectoryStoreState, Store } from '../../types';
import { getFilteredStores } from '../../reducers/stores';
import { useDispatch, useMappedState } from 'redux-react-hook';
import { fetchStoreExtensions } from '../../actions';
import { useCallback } from 'react';
import { ExtensionsList } from '../ExtensionList';
import Highlight from 'react-highlighter';

export interface StoreItemProps {
  index: number;
}

export const StoreItem: React.FC<StoreItemProps> = ({ index }: { index: number }) => {
  const { store, searchQuery, isIntegrationUrl, fetchExtensions } = useStore(index);

  return (
    <div className="storeItem">
      <div className="storeItem-header storeItem-header--link" onClick={fetchExtensions}>
        <div>
          <Highlight search={searchQuery}>{store.store}</Highlight> Tel:&nbsp;
          {isIntegrationUrl ? (
            <Highlight search={searchQuery}>{store.number}</Highlight>
          ) : (
            <a href={`tel:${store.number}`}>
              <Highlight search={searchQuery}>{store.number}</Highlight>
            </a>
          )}
        </div>
        {store.store_api_uuid && <Highlight search={searchQuery}>{store.store_api_uuid}</Highlight>}
      </div>
      <ExtensionsList storeId={store.id} sloc={store.sloc} number={store.number} />
    </div>
  );
};

function useStore(
  index: number
): {
  store: Store;
  searchQuery: string;
  isIntegrationUrl: boolean;
  fetchExtensions: () => void;
} {
  const { store, searchQuery, isIntegrationUrl } = useMappedState(
    useCallback(
      (state: DirectoryStoreState) => ({
        store: getFilteredStores(state)[index],
        searchQuery: state.stores.searchQuery,
        isIntegrationUrl: !!state.queryString.integrationURL,
      }),
      [index]
    )
  );

  const dispatch = useDispatch();
  const fetchExtensions = useCallback(() => dispatch(fetchStoreExtensions(store.id)), [
    index,
    store.id,
  ]);

  return { store, searchQuery, isIntegrationUrl, fetchExtensions };
}
